var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor google-drive-download-file" }, [
    _c(
      "section",
      [
        _c("div", { staticClass: "title" }, [_vm._v("Channel ID")]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Google Drive Channel ID",
            "show-attributes": true,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.channelId,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "channelId", $$v)
            },
            expression: "clone.channelId",
          },
        }),
        _vm._v(" "),
        _c("small", [_vm._v("Dosyanın indirileceği Google Drive kanal ID'si")]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "section",
      [
        _c("div", { staticClass: "title" }, [_vm._v("File ID")]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Google Drive File ID",
            "show-attributes": true,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.fileId,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "fileId", $$v)
            },
            expression: "clone.fileId",
          },
        }),
        _vm._v(" "),
        _c("small", [_vm._v("İndirilecek dosyanın Google Drive ID'si")]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }